import React, { useState, useEffect } from "react";
import './style.scss';
import { EditOutlined, DeleteOutlined, LoadingOutlined, TableOutlined, AppstoreOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { blue, red } from '@ant-design/colors';
import { Layout, Table, Checkbox, Button, Space, PageHeader, Radio, Tag } from 'antd';
import MenuForm from './menu-item-form';
import DashboardService from "../../services/DashboardService";
import MenuService from "../../services/MenuService";
import R2Footer from "../../components/Footer";
import { useHistory, useParams } from "react-router";
import _ from 'lodash';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MenuItemCard from "./MenuItemCard";

const { Content } = Layout;

const columns = [
    // {
    //     title: 'Action',
    //     render: () => {
    //         return <div>
    //             <EditOutlined style={{ color: blue[5] }} /> &nbsp;&nbsp;
    //             <EyeInvisibleOutlined style={{ color: red[5] }} alt="Deactivate" />
    //         </div>
    //     }
    // },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: 200,
        render: (text, record) => <b style={{ color: blue[5], cursor: 'pointer' }}>
            {text}&nbsp;&nbsp;{!record.is_active ? <Tag color="red">Inactive</Tag> : null}
        </b>
    },
    {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
        render: (text) => <span>${text}</span>
    },
    {
        title: 'Description',
        dataIndex: 'description',
        key: 'description'
    },
    {
        title: 'Vegetarian',
        dataIndex: 'is_vegetarian',
        key: 'is_vegetarian',
        render: (c) => <Checkbox checked={c} />
    },
    {
        title: 'Vegan',
        dataIndex: 'is_vegan',
        key: 'is_vegan',
        render: (c) => <Checkbox checked={c} />
    },
    {
        title: 'Gluten-Free',
        dataIndex: 'is_gluten_free',
        key: 'is_gluten_free',
        render: (c) => <Checkbox checked={c} />
    }
];

const modes = { table: 'table', cards: 'cards' };

const MenuItemList = (props) => {
    const [loading, setLoading] = useState(true);
    const [all_menu_items, setAllMenuItems] = useState([]);
    const [menu_items, setMenuItems] = useState([]);
    const [mode, setMode] = useState(modes.cards);
    const [showInactive, setShowInactive] = useState(false);
    const history = useHistory();
    const params = useParams();

    useEffect(() => {
        getMenuItems();
    }, [])

    const getMenuItems = async () => {
        // const restaurants = await DashboardService.getRestaurantsByUser();
        // const restaurant_id = restaurants[0].id;
        // const restaurant_id = localStorage.getItem('restaurantId')
        const restaurant_id = props.adminRestaurant;
        const data = await MenuService.getMenuItems(restaurant_id);
        setAllMenuItems(data.menu_items);

        const filteredMenuItems = _.filter(data.menu_items, { is_active: true });
        setMenuItems(filteredMenuItems);

        setLoading(false);
    }

    const toggleInactiveItems = () => {
        if (showInactive) {
            setShowInactive(false);
            const filteredMenuItems = _.filter(all_menu_items, { is_active: true });
            setMenuItems(filteredMenuItems);
        } else {
            setShowInactive(true);
            setMenuItems(all_menu_items);
        }
    }

    return (
        <Layout style={{ padding: '0 24px 24px', background: "transparent" }}>
            <Content
                style={{
                    padding: 24,
                    margin: '16px 0px',
                    minHeight: 280,
                }}
            >
                {
                    loading ?
                        <LoadingOutlined style={{ fontSize: '30px' }} />
                        :
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <PageHeader
                                title={params.menuName ? (params.menuName + " - Menu Items") : "Menu Items"}
                                onBack={() => history.goBack()}
                                extra={[
                                    params.menuId && <Button type="primary" onClick={() => history.push(`/menus//${params.menuId}/menu-items/add`)}>Add Menu Item</Button>,
                                    <Button onClick={toggleInactiveItems}>Show {showInactive ? "Active" : "Inactive"} Items</Button>,
                                    <Radio.Group value={mode} onChange={e => setMode(e.target.value)}>
                                        <Radio.Button value={modes.table}>
                                            <TableOutlined />
                                        </Radio.Button>
                                        <Radio.Button value={modes.cards}>
                                            <AppstoreOutlined />
                                        </Radio.Button>
                                    </Radio.Group>
                                ]} />
                            {mode === 'table' ? <Table columns={columns} dataSource={menu_items} onRow={(menu_item) => {
                                return {
                                    onClick: event => {
                                        history.push(`/menus/${menu_item.menu_id}/menu-items/edit/${menu_item.id}`)
                                    }
                                }
                            }} /> : menu_items.map(menuItem => (
                                <MenuItemCard key={menuItem.id} menuItem={menuItem} />
                            ))
                            }
                        </Space>
                }
            </Content>
            <R2Footer />
        </Layout>
    )
}

const mapStateToProps = state => {
    return {
        adminRestaurant: state.admin,
    };
};
export default withRouter(connect(
    mapStateToProps
)(MenuItemList));
